import { render } from "./ProfileDialog.vue?vue&type=template&id=68661d9a"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__